var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#169CEE;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.1,31H17c-1.8,0-2.8,1.1-2.8,2.6c0,1.4,0.9,2.4,2.3,2.4c1.6,0,2.5-1.1,2.6-2.6h3.5 c-0.2,3.8-2.6,5.8-6.1,5.8c-3.3,0-5.8-2.2-5.8-5.6c0-3.5,2.6-5.9,6.5-5.9h11.9c4,0,7.1-3,7.1-6.9c0-4-2.7-6.9-6.6-6.9 c-3.9,0-7,2.8-7,8v3.4h-3.5v-3.4c0-6.9,4.4-11.4,10.6-11.4c5.9,0,10.1,4.2,10.1,10.2C39.8,26.6,35.2,31,29.1,31L29.1,31z M25,49.5 c13.7,0,24.5-10.8,24.5-24.5S38.7,0.5,25,0.5S0.5,11.4,0.5,25C0.5,38.7,11.3,49.5,25,49.5L25,49.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParse);
export default __webpack_public_path__ + "static/media/parse.0dd4665434e72a9f73dbe2c1a4e2aeec.svg";
export { ForwardRef as ReactComponent };